(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Scroll Animation Observer ---
  function initScrollAnimations() {
    var animatedEls = document.querySelectorAll('[data-animate]');

    if (REDUCED_MOTION) {
      // Immediately show all elements, no animation
      animatedEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-delay');
          if (delay) {
            entry.target.style.transitionDelay = delay + 'ms';
          }
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    animatedEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  // --- Animated Counters ---
  function easeOutQuad(t) {
    return t * (2 - t);
  }

  function animateCounter(el) {
    var target = parseInt(el.getAttribute('data-count-to'), 10);
    var suffix = el.getAttribute('data-count-suffix') || '';
    var duration = 1500;
    var startTime = null;

    if (REDUCED_MOTION) {
      el.textContent = target + suffix;
      return;
    }

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var easedProgress = easeOutQuad(progress);
      el.textContent = Math.round(easedProgress * target) + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  function initCounters() {
    var counterEls = document.querySelectorAll('[data-count-to]');

    if (REDUCED_MOTION) {
      counterEls.forEach(function (el) {
        el.textContent = el.getAttribute('data-count-to') + (el.getAttribute('data-count-suffix') || '');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    counterEls.forEach(function (el) {
      el.textContent = '0' + (el.getAttribute('data-count-suffix') || '');
      observer.observe(el);
    });
  }

  // --- Hero Scroll Indicator ---
  function initHeroIndicator() {
    if (REDUCED_MOTION) return;

    var pairs = [
      { hero: '.about-story__hero', indicator: '.about-story__scroll-indicator' },
      { hero: '.wholesale-supply__hero', indicator: '.wholesale-supply__scroll-indicator' }
    ];

    pairs.forEach(function (pair) {
      var hero = document.querySelector(pair.hero);
      var indicator = document.querySelector(pair.indicator);
      if (!hero || !indicator) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            indicator.classList.add('is-hidden');
          }
        });
      }, { threshold: 0 });

      observer.observe(hero);
    });
  }

  // --- Init ---
  document.addEventListener('DOMContentLoaded', function () {
    initScrollAnimations();
    initCounters();
    initHeroIndicator();
  });
})();
